import React from "react";
import "../assets/css/footer.scss";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <p className="footer-text">
          <span className="glow-text">EnigmaTech</span> — Derryck Dowuona ©{" "}
          {year}
        </p>
        <div className="footer-social">
          <a
            href="https://github.com/EnigmaTechx"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <i className="fa fa-github"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/derryckniinoidowuona"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <i className="fa fa-linkedin"></i>
          </a>
          <a href="mailto:derryckdxd@gmail.com" aria-label="Email">
            <i className="fa fa-envelope"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
